import { createSlice } from "@reduxjs/toolkit";
import { fetch } from "./vats.service";

const VatsSlice = createSlice({
  name: "vats",
  initialState: {
    vatsCollection: [],
    isLoading: false,
    isError: false,
    errMsg: null,
    queryValue: null,
    filtersValue: {},
  },
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
      state.isError = false;
    },
    setVats(state, action) {
      state.isLoading = false;
      state.vatsCollection = action.payload.vatsCollection;
    },
    setError(state, action) {
      state.isError = true;
      state.errMsg = action.payload.errMsg;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = VatsSlice;

// Extract and export each action creator by name
export const { setLoading, setVats, setError, setFilterValue } = actions;

// Export the reducer, either as a default or named export
export default reducer;

export const fetchVats = (filtersValue) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { vatsCollection } = await fetch(filtersValue);
    dispatch(setVats({ vatsCollection }));
  } catch (e) {
    dispatch(setError(""));
  }
};
